import React from 'react'
import PropTypes from 'prop-types'
import DataSource from '../DataSource'
import ButtonWithLoader from '../elements/ButtonWithLoader'
import globals from '../globals'

class StreamInvoice extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoading: false,
            isLoaded: false
        }
    }

    streamInvoice (event) {
        event.preventDefault()
        this.setLoading()
        DataSource.getBlob(`${process.env.MIX_EXPERIENCE_API_URL}/v1/invoice-management/invoices/${this.props.data.id}/download`, true, response => {
            this.showFile(response)
            this.setLoaded()
            globals.pushEvent('DownloadCurrentInvoice')
        })
    }

    showFile (blob) {
        // It is necessary to create a new blob object with mime-type explicitly set otherwise only Chrome works like it should
        const newBlob = new Blob([blob], { type: 'application/pdf' })

        // IE doesn't allow using a blob object directly as link href instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
        }

        // For other browsers:  Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob)
        const link = document.createElement('a')

        link.setAttribute('href', data)
        link.setAttribute('download', `INV-${this.props.data.date}-E00${this.props.data.id}.pdf`)
        link.click()

        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data)
        }, 100)
    }

    setLoading () {
        this.setState({ isLoading: true, isLoaded: false })
    }

    setLoaded () {
        this.setState({ isLoading: false, isLoaded: true })
    }

    render () {
        if (this.props.children) {
            return (
                <a href='#' onClick={this.streamInvoice.bind(this)} className={`stream-invoice-link ${this.state.isLoading ? 'is-loading' : ''}`}>
                    {this.state.isLoading
                        ? <img src='/images/loader-anim-inline.svg' alt='Loading' />
                        : this.state.isLoaded ? <img src='/images/icon-tick-round.svg' alt='Loaded' /> : this.props.children}
                </a>
            )
        }

        return (
            <ButtonWithLoader
                title='Download invoice'
                isLoading={this.state.isLoading}
                isLoaded={this.state.isLoaded}
                action={this.streamInvoice.bind(this)}
            />
        )
    }
}

StreamInvoice.propTypes = {
    data: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        date: PropTypes.string.isRequired
    }).isRequired
}

StreamInvoice.defaultProps = {
    data: {}
}

export default StreamInvoice



// WEBPACK FOOTER //
// ./resources/js/components/StreamInvoice.js